import React from 'react';
import './assets/font.scss';
import App from './app';
import {store} from './store';
import './i18n';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';
import {PUBLIC_URL} from './config';

import {createRoot} from 'react-dom/client';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
    <Provider store={store}>
        <BrowserRouter basename={PUBLIC_URL}>
            <App />
        </BrowserRouter>
    </Provider>,
);
